import { ActionReducer, MetaReducer } from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';

import { SessionService } from '@global/services/session/session.service';

import { MainActions } from '@app/main/state/actions';
import { StpActions } from '@app/stp/state/actions';

import { CustomUtility } from '@app/infrastructure/helpers/custom-utility';

import { environment } from '@env/environment';
import { 
  MY_ACCOUNT_POLICY_DASHBOARD_URL,
  MY_ACCOUNT_PAYMENT_URL // URL constant for the payment redirection
} from '@app/infrastructure/constants';

let shouldRehydrate = true;
let clearSession = false;

export function sessionStorageSyncReducer(reducer: ActionReducer<any>) {
  return localStorageSync({
    keys: [
      'stpStore',
      'dashboardStore',
      'yourCarStore',
      'yourMileageStore',
      'renewalPreferenceStore',
      'yourVehicleUsageStore',
      'yourRegistrationStore',
      'yourAddressStore',
      'yourDetailsStore',
      'yourDriversStore',
      'yourConvictionsStore',
      'yourTemporaryEuropeanCover',
      'premiumStore',
      'reviewStore',
      'paymentStore',
      'allocateStore',
      'confirmStore',
      'whereIparkMyCarStore',
      'midTermCancellationStore'
    ],
    storage: sessionStorage,
    rehydrate: shouldRehydrate,
    removeOnUndefined: clearSession
  })(reducer);
}

export function clearState(reducer) {
  // tslint:disable-next-line:only-arrow-functions
  return function(state, action) {
    if (
      action.type === MainActions.redirectToMyAccountDashboard.type ||
      action.type === MainActions.redirectToMyAccountPayment.type || // New action
      action.type === StpActions.clearStore.type
    ) {
      shouldRehydrate = false;
      clearSession = true;
      SessionService.clearSession();

      if (action.type === MainActions.redirectToMyAccountDashboard.type) {
        setTimeout(() => {
          // prevent brief empty dashboard display when navigating back to My Account from Temp state
          state = undefined;
        });
        CustomUtility.redirectToExternalUrl(MY_ACCOUNT_POLICY_DASHBOARD_URL);
      } else if (action.type === MainActions.redirectToMyAccountPayment.type) {
        setTimeout(() => {
          state = undefined;
        });
        CustomUtility.redirectToExternalUrl(MY_ACCOUNT_PAYMENT_URL); // Redirect to the payment URL
      } else {
        state = undefined;
      }
      return reducer(state, action);
    }
    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<{}>[] = [clearState, sessionStorageSyncReducer, ...!environment.production ? [] : []];
